import { sanitizeData } from "../../utils/centralized-logging/sanitizeUtils";

const getLoggingConfig = () => {
  const baseUrl = process.env.REACT_APP_CENTRALIZED_LOGGING_API_URL;
  const apiKey = process.env.REACT_APP_CENTRALIZED_LOGGING_API_KEY;
  const userKey = process.env.REACT_APP_SCALE_USER_KEY;
  if (!baseUrl) return null;
  return {
    url: `${baseUrl.replace(/\/$/, "")}/api/logging/event`,
    apiKey,
    userKey,
  };
};

export const loggingService = {
  async logEvent(request) {
    const config = getLoggingConfig();
    if (config?.apiKey) {
      try {
        const sanitizedRequest = {
          ...request,
          additionalData:
            request?.additionalData == null
              ? undefined
              : sanitizeData(request.additionalData),
        };

        const headers = {
          "Content-Type": "application/json",
          "X-API-Key": config.apiKey,
        };
        if (config.userKey) {
          headers["user_key"] = config.userKey;
        }

        const response = await fetch(config.url, {
          method: "POST",
          headers,
          body: JSON.stringify(sanitizedRequest),
        });

        if (response.status !== 202) {
          console.error(
            "[CentralizedLogging] Error al registrar evento - Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error en servicio de logging centralizado:", error);
      }
    } else if (process.env.NODE_ENV === "development") {
      console.warn(
        "[CentralizedLogging] REACT_APP_CENTRALIZED_LOGGING_* no configurados. Log no enviado."
      );
    }
  },
};
